import $http from "../../axios";
import { Notification } from "element-ui";

export async function sendMessages(
    { commit, state },
    data = state.sendMessagesPayload
) {
    await $http
        .post("/api/ws/send-messages", data)
        .then(response => {
            commit("setResponseApi", response.data);
        })
        .catch(error => {
            commit("setResponseApi", error.response.data);
        });
}

export async function getTemplates({ commit }) {
    await $http
        .get("/api/ws/templates")
        .then(response => {
            const data = response.data.data;
            commit("setTemplates", data);
            commit(
                "setDefaultTemplate",
                data.find(item => item.name === "hello_world")
            );
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function getScheduledMessages({ commit }, params = {}) {
    try {
        const response = await $http.get('/api/ws/whatsapp/scheduled-messages', { params })
        commit('setScheduledMessages', response.data.data)
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box'
        })
    }
}

export async function updateScheduledMessage({ commit }, { id, data }) {
    try {
        const response = await $http.put(`/api/ws/whatsapp/scheduled-messages/${id}`, data)
        return response.data
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box'
        })
    }
}

export async function previewScheduledMessage({ commit }, { id, templateId = null }) {
    try {
        const params = templateId ? { template_id: templateId } : {}
        const response = await $http.get(`/api/ws/whatsapp/scheduled-messages/${id}/preview`, { params })
        return response.data.data
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box'
        })
    }
}

  export async function deleteScheduledMessage({ commit }, id) {
    try {
        const response = await $http.delete(`/api/ws/whatsapp/scheduled-messages/${id}`)
        return response.data
    } catch (error) {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 2000,
            customClass: 'notification-box'
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/whatsapp-api/actions.js